import {Pipe, PipeTransform} from '@angular/core';
import { UtilHelper } from '../index';

@Pipe({ name: 'cpfMask' })
export class CpfPipe implements PipeTransform {

  transform(value: string) {
    if (value) {

      if (value.length <= 11) {
        const adicionar: number = 11 - value.length;
        value = '0'.repeat(adicionar) + value;
      }

      value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }

    return value;
  }
}

@Pipe({ name: 'cnpjMask' })
export class CnpjPipe implements PipeTransform {

    transform(value: string){
       if (value){
            value = UtilHelper.lpad(value.toString(), 14);
            
            if (value.length === 14) {

                value = value.replace(/^[A-Z0-9]/g, '');
                value = value.replace(/^([A-Z0-9]{2})([A-Z0-9])/, '$1.$2');
                value = value.replace(/^([A-Z0-9]{2})\.([A-Z0-9]{3})([A-Z0-9])/, '$1.$2.$3');
                value = value.replace(/\.([A-Z0-9]{3})([A-Z0-9])/, '.$1/$2');
                value = value.replace(/([A-Z0-9]{4})([A-Z0-9])/, '$1-$2');

                return value;
            }
        }
        return value;
    }
}

@Pipe({ name: 'telefoneMask' })
export class TelefonePipe implements PipeTransform {
  transform(value: string) {
    if (value) {
      value = value.toString();

      value = value.replace(/\D/g, '');
      if (value.length === 11) {
        value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      } else {
        value = value.replace(/^(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      }

      return value;
    }

    return value;
  }
}

@Pipe({ name: 'cepMask' })
export class CepPipe implements PipeTransform {
  transform(value: string) {
    if (value) {
      value = value.toString();

      if (value.length === 8) {
        value = value.replace(/\D/g, '');
        value = value.replace(/^(\d{2})(\d{3})(\d)/, '$1.$2-$3');
        return value;
      }
    }

    return value;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/filters-br.pipe.ts